import {
  Injectable,
  inject,
} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {
  combineLatest,
  Observable,
  Subscription,
} from 'rxjs';
import {map} from 'rxjs/operators';
import {AppTranslateService} from '../../i18n/translate/app-translate/app-translate.service';
import {Constants} from '../../../../../common/constants/constants';

const TAB_TITLE_KEY = 'front.sng.tab.title';

@Injectable({
  providedIn: 'root',
})
export class TitleService {

  private title: Title = inject(Title);

  private appTranslateService: AppTranslateService = inject(AppTranslateService);

  private titleSubscription?: Subscription;

  /**
   * Method: Add title for Tab in browser
   * @param titleKey
   */
  public setTitle(titleKey?: string): void {
    this.titleSubscription?.unsubscribe();

    const tabObservable: Observable<string> = this.appTranslateService.stream(TAB_TITLE_KEY);
    const titleObservable: Observable<string> = titleKey
      ? combineLatest([this.appTranslateService.stream(titleKey), tabObservable]).pipe(
        map(([page, tab]) => page + Constants.HYPHEN_WITH_SPACES + tab),
      )
      : tabObservable;

    this.titleSubscription = titleObservable.subscribe(title => this.title.setTitle(title));
  }

}
